import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { AIRPORTS_JSON_PATH, CENTRALIZED_JSON_INFO, FLIGHT_EDIT_PRICE, NEWS_LETTER_SUBSCRIPTION, S3_FASTFIX_PATH } from 'src/constants/constants';
import { ApiService } from '@app/general/services/api/api.service';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class SharedCommonService {
  constructor(private httpClient: HttpClient, private apiService: ApiService) {}
  baseUrl = this.apiService.apiBaseUrl();
  public getUserCountry() {
    const url = `https://api.country.is/`;
    return this.httpClient.get(url);
  }
  /**Fetching the translations*/
  getAirportsJsonData() {
    const url = `${S3_FASTFIX_PATH}${AIRPORTS_JSON_PATH}`;
    return this.httpClient.get(url);
  }
  public getPriceUpdationEmails(params: any) {
    return this.httpClient.get(this.baseUrl + FLIGHT_EDIT_PRICE, { params });
  }

  public checkRates(data: any) {
    /**we can enable this once checkrates available
     * const url = `${this.baseUrl}${CHECK_RATES}?${this.queryString.getParamApiPath()}`;
     * return this.httpClient.post(url, data);
     */
    return this.httpClient.post('', data);
  }
  
  /**here we are integrated AWS lambda function for notifications for News-Letter subscribtion*/
  public subscribeToNewsLetter(UserEmail: any,reciverEmail:any) {
    const requestPayload = {
      sender_email : reciverEmail,
      subscriber_email : UserEmail
    }
    const Url = this.baseUrl + NEWS_LETTER_SUBSCRIPTION;
    return this.httpClient.post(Url, requestPayload);
  }
  manageDeeplinks(url:any){
    return this.httpClient.get(url);
  }
    download(file: string | undefined, link: any): Observable<Blob> {
      return this.httpClient.get(link, {
        responseType: 'blob',
      });
    }
    downloadExcelFiles(filename: any, downloadable_Link: any) {
      this.download(filename, downloadable_Link).subscribe((file) => {
        const a = document.createElement('a');
        a.setAttribute('type', 'hidden');
        a.href = URL.createObjectURL(file);
        a.download = filename + '.xlsx';
        a.click();
        a.remove();
      });
    }
    /**here to get centerlized content from s3 */
    getB2BCenterlizedJSONData(){
      const url = `${S3_FASTFIX_PATH}${CENTRALIZED_JSON_INFO}`;
      return this.httpClient.get(url);
    }
}
